(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bpets-nav-title"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) return;
    function cargar() {
      document.querySelectorAll('img.bp-nav-ico__anim[data-src]').forEach(function (img) {
        img.addEventListener('load', function () { img.parentNode.classList.add('is-anim'); }, { once: true });
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    }
    function luego() {
      if ('requestIdleCallback' in window) { requestIdleCallback(cargar, { timeout: 4000 }); } else { setTimeout(cargar, 2000); }
    }
    if (document.readyState === 'complete') { luego(); } else { window.addEventListener('load', luego); }
  })();
  } catch(e) { console.error(e); }
})();

})();
